import { initialErrors } from '../Constants/Areas-constants';
import { Types } from '../Constants/Types';

import AreaType from '../Interfaces/area-interface';

const AreaReducer = (
  state: AreaType['status'] = {
    area: undefined,
    areas: [],
    lareas: false,
    larea: false,
    ldelete: false,
    error: initialErrors,
    pages: 0,
    total: 0,
  },
  action: AreaType['action']
) => {
  switch (action.type) {
    case Types.FETCH_AREAS:
      return {
        ...state,
        areas: action.payload,
        pages: action.pages,
        total: action.total,
      };

    case Types.START_AREAS:
      return { ...state, lareas: true };

    case Types.START_AREA:
      return { ...state, larea: true };

    case Types.END_AREAS:
      return { ...state, lareas: false };

    case Types.FETCH_AREA:
      return { ...state, area: action.payload };

    case Types.CREATE_AREAS:
      return { ...state, areas: [action.payload, ...state.areas] };

    case Types.UPDATE_AREA:
      return {
        ...state,
        areas: state.areas.map((area) =>
          area._id === action.payload.id ? action.payload : area
        ),
      };

    case Types.DELETE_AREA:
      return {
        ...state,
        areas: state.areas.filter((area) => area._id !== action.payload),
      };

    case Types.TOGGLE_AREA_ACTIVE:
      return {
        ...state,
        areas: state.areas.map((area) =>
          area._id === action.payload.id
            ? { ...area, isActive: action.payload.isActive }
            : area
        ),
      };

    case Types.RESET_AREAS:
      return { ...state, error: initialErrors };

    case Types.RESET_AREA:
      return { ...state, error: initialErrors };

    case Types.END_AREA:
      return { ...state, larea: false };

    case Types.ERROR_AREA:
      return {
        ...state,
        error: action?.payload
          ? { ...state.error, [action?.field!]: action.payload }
          : { ...state.error, [action?.field!]: null },
      };

    default:
      return state;
  }
};

export default AreaReducer;
